export const coBuyQueryInit = {
  page: 1,
  take: 10,
  search: '',
  order: { name: 'createdAt', value: 0 },
};

export const productQuery = {
  page: 1,
  take: 10,
  search: '',
  select: [
    'id',
    'slug',
    'code',
    'name',
    'status',
    'avatar',
    'price',
    'code',
    'totalSupplierProposedQuantity',
    'totalCustomerOrderQuantity',
    'ownerID',
    'retailUnit',
    'unitPrefix',
    'unitWeight',
    'unitPostfix',
    'createdAt',
    'coBuyPromotions',
    'entitySubCategory.id',
    'entitySubCategory.name',
    'entityCategory.id',
    'entityCategory.displayName',

    'productOptions.id',
    'option.id',
    'option.content',
    'color.id',
    'color.code',
  ],
  relations: [
    'productOptions',
    'productOptions.option',
    'productOptions.option.color',

    'entitySubCategory',
    'entitySubCategory.entityCategory',
  ],
  order: { createdAt: 0 },
};

export const option = {
  isVisible: true,
  whiteList: ['order', 'take', 'page', 'where', 'tab'],
};

export const coBuyBase = {
  relations: [
    'coBuyProducts',
    'coBuyMembers',
    'coBuyProducts.product',
    'coBuyProducts.product.productOptions',
    'coBuyProducts.product.productOptions.option',
    'coBuyProducts.product.productOptions.option.color',
    'coBuyProducts.product.subCategory',
    'coBuyProducts.product.subCategory.category',
    'coBuyMembers.member',
  ],
};
